<template>
  <div
    class="Container"
    v-if="
      this.accessGroup.includes('OVR') ||
        this.userType.includes('SUP') ||
        this.userType.includes('SYS') ||
        this.userType.includes('SEN')
    "
  >
    <div :key="componentKey">
      <script type="application/javascript" src="@/Services/auth.js"></script>
      <!-- <div v-if="profileportal === 'SEN'">
      <SenOverview />
      </div> -->
      <div v-if="profileportal != 'SEN'">
      <Overview />
    </div>
     
     
    </div>
  </div>
</template>

<script>
import store from "../store";
// import SenOverview from "@/components/OverviewSen";
import Overview from "@/views/OverviewData";
// import axios from "axios";

export default {
  components: {
    Overview,
    // SenOverview
  },
  computed: {},

  beforeMount() {
    this.themepref = store.state.themepref;
    this.themepref = store.state.themepref;
    this.userType = store.state.profileportal;
    this.accessGroup = store.state.accessGroup;
    this.UserURNSubmit = this.$UserURN;
  },
  created() {
    this.$auth.renewTokens().catch((err) => {
      err.message;
    });
  },

  data() {
    return {
      profileportal: null,
      Auth0loggedIn: false,
      profile: {},
      themepref: "dark",
      accessGroup: null,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      componentKey: 0,
      UserURNSubmit: "",
    };
  },

  mounted() {
    // let LookUpUrl =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/DEV/attachments";
    // let LookUpHeaders = this.$apikeyPost;
    // this.LookUpRequest = {
    //   RequestType: "LoadAll",
    //   RequestVariable: this.DeviceID,
    // };
    // axios
    //   .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
    //   .then((response) => {
    //     response;
    //     this.testing = response.data.field_names;
    //     this.items = response.data.Values;
    //     for (let i = 0; i < this.testing.length; i++) {
    //       var QuoteStr = "" + i + "";
    //       this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
    //     }
    //     this.UserHeaders = this.ArrTest;
    //     this.UserHeaders.push("Action");
    //     this.ArrTest = [];
    //   });
    // let LookUpUrlData =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/dashboard";
    // let LookUpHeadersData = this.$apikeyPost;
    // this.LookUpRequest = {
    //   Report: "Overview",
    //   RequestVariable: this.selectedlocation,
    // };
    // axios
    //   .post(LookUpUrlData, this.LookUpRequest, LookUpHeadersData)
    //   .then((response) => {
    //     response;
    //     let NotificationsList = response.data.FiveRecentAlerts;
    //     for (let i = 0; i < NotificationsList.length; i++) {
    //       let color = "";
    //       if (NotificationsList[i][5] == "3") {
    //         color = "danger";
    //       } else if (NotificationsList[i][5] == "2") {
    //         color = "warning";
    //       } else {
    //         color = "success";
    //       }
    //       this.NotificationsArray.push({
    //         Level: NotificationsList[i][5],
    //         ID: NotificationsList[i][0],
    //         DeviceID: NotificationsList[i][1],
    //         Location: NotificationsList[i][2],
    //         InitiatedBy: NotificationsList[i][3],
    //         Date: NotificationsList[i][4],
    //         Time: NotificationsList[i][5],
    //         Note: NotificationsList[i][4],
    //         Category: NotificationsList[i][7],
    //         Acknowledged: NotificationsList[i][8],
    //         variantColor: color,
    //         Action: "",
    //       });
    //     }
    // INSERT FOR LOOP TO MAKE NOTIFICATIONS
    //   this.TrendCounts = {
    //     UpTrendCount: response.data.TrendCounts[1].UpTrendCount,
    //     DownTrendCount: response.data.TrendCounts[0].DownTrendCount,
    //     StableTrendCount: response.data.TrendCounts[2].StableTrendCount,
    //   };
    //   this.chartOptionsLine = {
    //     dataLabels: {
    //       enabled: false,
    //     },
    //     title: {
    //       text: "7 Day Handwash Flow Data",
    //       align: "center",
    //     },
    //     legend: {
    //       show: true,
    //     },
    //     chart: {},
    //     sparkline: {
    //       enabled: true,
    //     },
    //     fill: {
    //       opacity: 1,
    //     },
    //     xaxis: {
    //       categories: response.data.SevenDayFlows.UnitIDs,
    //       labels: {
    //         show: true,
    //       },
    //     },
    //     yaxis: {
    //       labels: {
    //         show: true,
    //       },
    //     },
    //     colors: ["#17a2b8", "#7BF0B7"],
    //     grid: {
    //       show: true, // you can either change hear to disable all grids
    //       xaxis: {
    //         lines: {
    //           show: true, //or just here to disable only x axis grids
    //         },
    //         labels: {
    //           show: false,
    //         },
    //       },
    //       yaxis: {
    //         lines: {
    //           show: false, //or just here to disable only y axis
    //         },
    //         axisBorder: {
    //           show: false,
    //         },
    //         labels: {
    //           show: false,
    //         },
    //         axisTicks: {
    //           show: false,
    //         },
    //       },
    //     },
    //   };
    //   this.seriesLine = [
    //     {
    //       name: "No of Flushes",
    //       data: response.data.SevenDayFlows.SevenDayFlushes,
    //     },
    //     {
    //       name: "No of Handwashes",
    //       data: response.data.SevenDayFlows.SevenDayHandwashes,
    //     },
    //   ];
    //   this.donutOptions = {
    //     series: [
    //       response.data.RiskLevelCounts.ExtremelyHighRiskCount,
    //       response.data.RiskLevelCounts.HighRiskCount,
    //       response.data.RiskLevelCounts.ModerateRiskCount,
    //       response.data.RiskLevelCounts.LowRiskCount,
    //     ],
    //     labels: [
    //       "Extremely High Risk",
    //       "High Risk",
    //       "Moderate Risk",
    //       "Low Risk",
    //     ],
    //     plotOptions: {
    //       pie: {
    //         donut: {
    //           labels: {
    //             show: true,
    //             total: {
    //               show: true,
    //               label: "Total No of devices",
    //             },
    //           },
    //         },
    //       },
    //     },
    //     dataLables: {
    //       enabled: false,
    //     },
    //     legend: {
    //       show: true,
    //     },
    //     colors: ["#dc3545", "#F05E16", "#ffc107", "#28a745"],
    //   };
    // });
  },

  methods: {
    handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
    },
  },

  watch: {},
};
</script>
<style></style>
